import React, { useState, useEffect, useCallback } from 'react';
// import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ENDPOINTS } from '../Helper/endpoints';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Footer from "./Footer";
import { debounce } from "lodash";

const getCookie = (cookieName) => {
  const cookies = document.cookie.split('; ');
  for (let cookie of cookies) {
    const [name, value] = cookie.split('=');
    if (name === cookieName) return decodeURIComponent(value);
  }
  return null;
};

const VendorList = ({ setCurrentPage }) => {
  const [vendors, setVendors] = useState([]);
  // const [loading, setLoading] = useState(true);
  // const [error, setError] = useState(null);
  const [userInfo, setUserInfo] = useState(null);
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  // const [tableData, setTableData] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    address: '',
    email: '',
    pan_card_no: '',
    GSTIN: ''
  });

  // const navigate = useNavigate();
  useEffect(() => {
    try {
      const userData = getCookie("userSession");
      if (userData) {
        const parsedUserData = JSON.parse(userData);
        setUserInfo(parsedUserData.data);
      }
    } catch (e) {
      console.error("Error parsing user info from cookies:", e);
    }
  }, []);
    const getOrganizationPid = useCallback(() => {
      return userInfo?.user_info?.organizations_pid || null;
    }, [userInfo]);
    const fetchVendors = useCallback(() => {
      const pid = getOrganizationPid();
      if (!pid) {
        // setError("Organization PID not found");
        // setLoading(false);
        return;
      }
      axios
        .get(ENDPOINTS.VENDOR_INFO, { params: { organization_pid: pid } })
        .then((response) => {
          if (response.data?.status && Array.isArray(response.data.data)) {
            setVendors(response.data.data);
          } else {
            console.error("Unexpected API response structure:", response.data);
            setVendors([]);
          }
          // setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching data:", error.message);
          // setError(error.message);
          // setLoading(false);
        });
    }, [getOrganizationPid]);
    useEffect(() => {
      if (userInfo) {
        fetchVendors();
      }
    }, [userInfo, fetchVendors]);
    const debouncedSearch = useCallback(
  (value) => {
    debounce((val) => {
      if (val.trim() === "") {
        fetchVendors();
      } else {
        const filtered = vendors.filter((vendor) =>
          vendor.name.toLowerCase().includes(val.toLowerCase())
        );
        setVendors(filtered);
      }
    }, 500)(value);
  },
  [vendors, fetchVendors]
);
    const handleSearchChange = (e) => {
      const value = e.target.value;
      setSearchTerm(value);
      debouncedSearch(value);
    }; 
  const handleDelete = (vendor_pid) => {
    if (!userInfo?.user_info?.organizations_pid) {
      console.error('Organization PID not found.');
      return;
    }
    const organization_pid = userInfo.user_info.organizations_pid;  
    Swal.fire({ title: "Are you sure?", text: "You won't be able to revert this!", icon: "warning",
      showCancelButton: true, confirmButtonColor: "#d33", cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",customClass: {popup: "small-swal-popup"}
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(ENDPOINTS.VENDOR_DELETE, {
            params: { organization_pid, vendor_pid },
          })
          .then((response) => {
            if (response.status === 200) {
              setVendors((prevVendors) => prevVendors.filter((vendor) => vendor.pid !== vendor_pid));
              Swal.fire({title: "Deleted!",text: "Vendor has been deleted.",icon: "success",
                timer: 1500, showConfirmButton: false, customClass: { popup: "small-swal-popup" }
              });
            } else {
              throw new Error("Failed to delete vendor.");
            }
          })
          .catch((error) => {
            Swal.fire({ title: "Error!", text: "Something went wrong.", icon: "error",
              timer: 1500, showConfirmButton: false, 
              customClass: { popup: "small-swal-popup" } });
            console.error('Error deleting vendor:', error.message);
          });
      }
    });
  };
  const handleUpdate = (vendor) => {
    console.log("Updating vendor:", vendor);
    setSelectedVendor(vendor);
    setFormData({
      name: vendor.name || '',
      mobile: vendor.mobile || '',
      address: vendor.address || '',
      email: vendor.email || '',
      pan_card_no: vendor.pan_card_no || '',
      GSTIN: vendor.GSTIN || '',
      aadhar_no: vendor.aadhar_no || '',
      account_holder_name: vendor.account_holder_name || '',
      account_number: vendor.account_number || '',
      IFSC_code: vendor.IFSC_code || '',
      bank_name: vendor.bank_name || '',
      branch: vendor.branch || '',
      UPI_ID: vendor.UPI_ID || '',
    });
    setShowUpdateForm(true);
  };
  
  
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (!userInfo?.user_info?.organizations_pid || !selectedVendor) {
      return;
    }
    try {
      const response = await axios.put(ENDPOINTS.VENDOR_UPDATE, formData, {
        params: { vendor_pid: selectedVendor?.pid }
      });
      
      

      if (response.status === 200) {
        setVendors(vendors.map(vendor =>
          vendor.pid === selectedVendor.pid ? { ...vendor, ...formData } : vendor
        ));
        
        setShowUpdateForm(false);
        setSelectedVendor(null);
        Swal.fire({ title: "Updated!", text: "Vendor has been updated successfully.",
          icon: "success", timer: 1500, showConfirmButton: false,
          customClass: { popup: "small-swal-popup"} });
      }
    } catch (error) {
      console.error('Error updating vendor:', error);
      Swal.fire({
        title: "Error!", text: "Failed to update vendor.", icon: "error", timer: 1500, showConfirmButton: false,
        customClass: { popup: "small-swal-popup" } }); } };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleDownload = () => {
    if (vendors.length === 0) {
      Swal.fire({
        title: "No Data!", text: "There are no vendors to download.", icon: "warning",
        timer: 1500, showConfirmButton: false, customClass: { popup: "small-swal-popup" }
      });
      return;
    }
    // Define the Excel headers and data
    const data = vendors.map(vendor => ({
      "Vendor Name": vendor.name,
      "Contact No": vendor.mobile,
      "Address": vendor.address,
      "Email": vendor.email,
      "PAN No": vendor.pan_card_no,
      "GST No": vendor.GSTIN,
      "Aadhar No": vendor.aadhar_no,
      "Account Name": vendor.account_holder_name,
      "Account No": vendor.account_number,
      "IFSC Code": vendor.IFSC_code,
      "Bank": vendor.bank_name,
      "Branch": vendor.branch,
      "UPI ID": vendor.UPI_ID,
    }));
    // Create a worksheet and workbook
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Vendors");
    // Generate Excel file and trigger download
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    saveAs(blob, "Vendor_List.xlsx");
  };
  return (
    <>
    <div className="vendor-list">
    <div className="button-container" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
  <h2 style={{ fontWeight: "bold", margin: 0 }}>Vendor List</h2>
  <div style={{ display: "flex", gap: "10px" }}>
    <input
      type="text"
      placeholder="Search Vendor"
      value={searchTerm}
      onChange={handleSearchChange}
      className="search-input-vendor"
    />
    <button className="download-button" onClick={handleDownload}>Download</button>
    <button className="add-vendor-button" onClick={() => setCurrentPage('VendorForm')}>Add Vendor</button>
  </div>
</div>
      {showUpdateForm && (
  <div className="update-form-container" style={{ marginBottom: '20px', padding: '20px', border: '1px solid #ddd', 
    borderRadius: '8px', backgroundColor: '#f9f9f9'}}>
    <h3>Update Vendor</h3>
    <form onSubmit={handleFormSubmit}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '15px' }}>
        <div>
          <label>Name:</label>
          <input type="text" name="name" value={formData.name} onChange={handleInputChange} />
        </div>
        <div>
          <label>Mobile:</label>
          <input type="text" name="mobile" value={formData.mobile} onChange={handleInputChange} />
        </div>
        <div>
          <label>Email:</label>
          <input type="email" name="email" value={formData.email} onChange={handleInputChange} />
        </div>
        <div>
          <label>Address:</label>
          <input type="text" name="address" value={formData.address} onChange={handleInputChange} />
        </div>
        <div>
          <label>PAN No:</label>
          <input type="text" name="pan_card_no" value={formData.pan_card_no} onChange={handleInputChange} />
        </div>
        <div>
          <label>GST No:</label>
          <input type="text" maxLength={"15"} name="GSTIN" value={formData.GSTIN} onChange={handleInputChange} />
        </div>
        <div>
          <label>Aadhar No:</label>
          <input type="text" name="aadhar_no" value={formData.aadhar_no} onChange={handleInputChange} />
        </div>
        <div>
          <label>Account Holder Name:</label>
          <input type="text" name="account_holder_name" value={formData.account_holder_name} onChange={handleInputChange} />
        </div>
        <div>
          <label>Account Number:</label>
          <input type="text" name="account_number" value={formData.account_number} onChange={handleInputChange} />
        </div>
        <div>
          <label>IFSC Code:</label>
          <input type="text" name="IFSC_code" value={formData.IFSC_code} onChange={handleInputChange} />
        </div>
        <div>
          <label>Bank Name:</label>
          <input type="text" name="bank_name" value={formData.bank_name} onChange={handleInputChange} />
        </div>
        <div>
          <label>Branch:</label>
          <input type="text" name="branch" value={formData.branch} onChange={handleInputChange} />
        </div>
        <div>
          <label>UPI ID:</label>
          <input type="text" name="UPI_ID" value={formData.UPI_ID} onChange={handleInputChange} />
        </div>
      </div>
      <div style={{ display: 'flex', gap: '10px' }}>
        <button type="submit" style={{ padding: '8px 16px',borderRadius:'5px',  backgroundColor: '#191056', color: 'white' }}>
          Update Vendor
        </button>
        <button type="button" onClick={() => { setShowUpdateForm(false); setSelectedVendor(null); }}
          style={{ padding: '8px 16px',borderRadius:'5px', backgroundColor: '#191056', color: 'white' }}>
          Cancel
        </button>
      </div>
    </form>
  </div> )}
      <table className="table table-bordered">
        <thead>
          <tr className="table-dark">
            <th style={{ backgroundColor: '#111c43' }}>Vendor Name</th>
            <th style={{ backgroundColor: '#111c43' }}>Contact No</th>
            <th style={{ backgroundColor: '#111c43' }}>Address</th>
            <th style={{ backgroundColor: '#111c43' }}>Email</th>
            <th style={{ backgroundColor: '#111c43' }}>PAN No</th>
            <th style={{ backgroundColor: '#111c43' }}>GST No</th>
            <th style={{ backgroundColor: '#111c43' }}>Action</th>
          </tr>
        </thead>
        <tbody>
            {vendors.length > 0 ? (
              vendors.map((vendor) => (
                <tr key={vendor.pid}>
                  <td>{vendor.name}</td>
                  <td>{vendor.mobile}</td>
                  <td style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word', maxWidth: '200px' }}>
  {vendor.address}
</td>

                  <td>{vendor.email}</td>
                  <td>{vendor.pan_card_no}</td>
                  <td>{vendor.GSTIN}</td>
                  <td>
                  <div style={{ display: "flex", gap: "10px" }}>
                    <button
                      style={{
                              padding: "6px 12px",
                              fontSize: "12px",
                              borderRadius: "4px",
                              border: "none",
                              cursor: "pointer",
                              color: "white",
                              transition: "all 0.3s ease-in-out",
                              backgroundColor: "#191056",
                            }}
                      onClick={() => handleUpdate(vendor)} >
                      Update
                    </button>
                    <button
                      style={{
                              padding: "6px 12px",
                              fontSize: "12px",
                              borderRadius: "4px",
                              border: "none",
                              cursor: "pointer",
                              color: "white",
                              transition: "all 0.3s ease-in-out",
                              backgroundColor: "#191056",
                            }}
                      onClick={() => handleDelete(vendor.pid)}>
                      Delete
                    </button>
                  </div>
                </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" style={{ textAlign: 'center', padding: '15px', fontSize: '16px', color: 'gray' }}>
                  No vendor available
                </td>
              </tr>
            )}
          </tbody>
      </table>
    </div>
    <Footer />
    </>
  );
};
export default VendorList;